import { ABOUT_CHAPTERS } from "../data/content";
import { PageIntro } from "../components/PageIntro";
import { Reveal } from "../components/Reveal";
import { VHSImage } from "../components/VHSImage";
import { BookButton } from "../components/Button";

export default function About() {
  return (
    <div data-testid="about-page">
      <PageIntro
        label="About"
        titleLines={["Same family.", "Same place.", "Since 1973."]}
        blurb="No wellness speak. No journeys. A bathhouse in Greenwich Village, and the family that has kept it."
      />

      <div className="mx-auto max-w-[1600px] px-5 md:px-10">
        {ABOUT_CHAPTERS.map((c, i) => (
          <section
            key={c.no}
            className={`grid items-center gap-10 border-b border-ink py-20 md:grid-cols-12 md:gap-16 md:py-28 ${
              i % 2 === 1 ? "md:[&>*:first-child]:order-2" : ""
            }`}
            data-testid={`about-chapter-${c.no}`}
          >
            <div className="md:col-span-6">
              <Reveal>
                <VHSImage
                  src={c.image}
                  alt={c.title}
                  className="aspect-[5/4] w-full"
                />
              </Reveal>
            </div>
            <div className="md:col-span-6">
              <span className="text-xs uppercase tracking-[0.25em] text-terracotta">
                {c.no} — {c.title}
              </span>
              <Reveal delay={0.05}>
                <p className="mt-6 text-2xl font-medium leading-[1.2] tracking-tight md:text-4xl">
                  {c.body}
                </p>
              </Reveal>
            </div>
          </section>
        ))}
      </div>

      <section className="mx-auto max-w-[1600px] px-5 py-24 text-center md:px-10 md:py-36">
        <p className="mx-auto max-w-2xl text-3xl font-medium leading-[1.15] tracking-tight md:text-5xl">
          Come see the place for yourself.
        </p>
        <div className="mt-10 flex justify-center">
          <BookButton />
        </div>
      </section>
    </div>
  );
}
